import React from 'react';
import { useSelector } from 'react-redux';

import { ExperimentOutlined } from '@ant-design/icons';

import { makeSelectAplDetail } from 'pages/product-apl-detail/controllers/selectors';
import { RibbonButton } from 'common/components';

import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';

import Messages from 'i18n/messages/apl';
import { MASTER_APL_NAME } from '../../sections/product-apl/constants';

const RequestSample = (props) => {
  const { productList, setModalVisible } = props;

  const aplDetail = useSelector(makeSelectAplDetail());

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn(aplDetail);

  const disabled =
    productList?.length === 0 ||
    productList?.some((product) => {
      return product?.manufacturerName !== productList?.[0]?.manufacturerName;
    });

  const checkDisabledRequestSampleBtn = () => {
    if (aplDetail?.aplName === MASTER_APL_NAME)
      return isDisabledMasterAplBtn || disabled;
    return disabled;
  };

  const isDisabled = checkDisabledRequestSampleBtn();
  const onClickButton = () => {
    setModalVisible(true);
  };

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<ExperimentOutlined />}
        label={Messages.requestSample}
        disabled={isDisabled}
        onClick={onClickButton}
      />
    </>
  );
};

export default RequestSample;
